import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '../../../codegen/Localize';
import { WelcomeChannelStateProps, WelcomeChannelTestIds } from '../../../home/components/WelcomeChannel';
import { HomeStyles } from '../../../home/styles/HomeStyles';
import { WelcomeChannelStyles } from '../../../home/styles/WelcomeChannelStyles';
import { WelcomeChannelCloseButton } from './WelcomeChannelCloseButton';

export class WelcomeChannelPreview extends React.PureComponent<WelcomeChannelStateProps> {

  render() {
    const primaryButton =
      <ButtonWidget
        buttonType={ButtonType.LightOutline}
        handleClick={() => {}}
        testId={WelcomeChannelTestIds.callToActionButton}
        disabled={true}
      >
        {this.props.primaryButtonLink.linkTitle}
      </ButtonWidget>;

    const closeButton =
      <WelcomeChannelCloseButton
        handleClick={() => {}}
        tooltipText={Messages.settings_welcomeChannel_dismiss_tooltip()}
        disabled={true}
      />;

    /* eslint-disable jsx-a11y/anchor-is-valid */
    return (
      <section className={`${WelcomeChannelStyles.root} ${HomeStyles.contentSection}`} style={{marginBottom: '0'}} data-tb-test-id={WelcomeChannelTestIds.welcomeChannel}>
        {closeButton}
        <h2 className={WelcomeChannelStyles.header}>{this.props.header}</h2>
        <p className={WelcomeChannelStyles.subheader}>{this.props.subHeader}</p>
        {primaryButton}
        <p className={WelcomeChannelStyles.links}>
          {this.props.bottomLinks.map((link, index) => (
            <React.Fragment key={index}>
              {index !== 0 && <span className={WelcomeChannelStyles.linkDivider}>|</span>}
              <a className={WelcomeChannelStyles.link}>
                {link.linkTitle}
              </a>
            </React.Fragment>
          ))}
        </p>
      </section>
    );
  }
}
